import type { ToastDesignTokens, ToastTokenSections } from '@primeuix/themes/types/toast';

// Rebrand 2026 (DS): toast = flat tint callout like message
export const root: ToastTokenSections.Root = {
    width: '25rem',
    borderRadius: '{overlay.popover.borderRadius}',
    borderWidth: '0',
    transitionDuration: '{transitionDuration}',
    blur: '0'
};

export const icon: ToastTokenSections.Icon = {
    size: '1.25rem'
};

export const content: ToastTokenSections.Content = {
    padding: '16px 18px',
    gap: '14px'
};

export const text: ToastTokenSections.Text = {
    gap: '4px'
};

export const summary: ToastTokenSections.Summary = {
    fontWeight: '600',
    fontSize: '0.875rem'
};

export const detail: ToastTokenSections.Detail = {
    fontWeight: '400',
    fontSize: '0.8125rem'
};

export const closeButton: ToastTokenSections.CloseButton = {
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '50%',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        offset: '{focusRing.offset}'
    }
};

export const closeIcon: ToastTokenSections.CloseIcon = {
    size: '1rem'
};

export const colorScheme: ToastTokenSections.ColorScheme = {
    light: {
        info: {
            background: '{blue.100}',
            borderColor: 'transparent',
            color: '{sand.950}',
            detailColor: '{grey.600}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(43, 127, 209, .12)',
                focusRing: {
                    color: '{blue.600}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {blue.600}, transparent 80%)'
                }
            }
        },
        success: {
            background: '{green.100}',
            borderColor: 'transparent',
            color: '{sand.950}',
            detailColor: '{grey.600}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(46, 139, 87, .12)',
                focusRing: {
                    color: '{green.500}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {green.500}, transparent 80%)'
                }
            }
        },
        warn: {
            background: '{yellow.200}',
            borderColor: 'transparent',
            color: '{sand.950}',
            detailColor: '{grey.600}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(245, 187, 27, .15)',
                focusRing: {
                    color: '{yellow.700}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {yellow.700}, transparent 80%)'
                }
            }
        },
        error: {
            background: '{extend.stateerrorbg}',
            borderColor: 'transparent',
            color: '{wine.900}',
            detailColor: '{wine.700}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(79, 29, 44, .10)',
                focusRing: {
                    color: '{wine.900}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {wine.900}, transparent 80%)'
                }
            }
        },
        secondary: {
            background: '{sand.100}',
            borderColor: 'transparent',
            color: '{sand.950}',
            detailColor: '{grey.600}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: '{sand.200}',
                focusRing: {
                    color: '{grey.600}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {grey.600}, transparent 80%)'
                }
            }
        },
        contrast: {
            background: '{sand.950}',
            borderColor: 'transparent',
            color: '#FFFFFF',
            detailColor: '{grey.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: '{grey.800}',
                focusRing: {
                    color: '#FFFFFF',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, #FFFFFF, transparent 80%)'
                }
            }
        }
    },
    dark: {
        info: {
            background: 'color-mix(in srgb, {blue.500}, transparent 84%)',
            borderColor: 'color-mix(in srgb, {blue.700}, transparent 64%)',
            color: '{blue.300}',
            detailColor: '{blue.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(255, 255, 255, 0.05)',
                focusRing: {
                    color: '{blue.300}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {blue.300}, transparent 80%)'
                }
            }
        },
        success: {
            background: 'color-mix(in srgb, {green.500}, transparent 84%)',
            borderColor: 'color-mix(in srgb, {green.700}, transparent 64%)',
            color: '{green.300}',
            detailColor: '{green.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(255, 255, 255, 0.05)',
                focusRing: {
                    color: '{green.300}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {green.300}, transparent 80%)'
                }
            }
        },
        warn: {
            background: 'color-mix(in srgb, {yellow.500}, transparent 84%)',
            borderColor: 'color-mix(in srgb, {yellow.700}, transparent 64%)',
            color: '{yellow.300}',
            detailColor: '{yellow.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(255, 255, 255, 0.05)',
                focusRing: {
                    color: '{yellow.300}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {yellow.300}, transparent 80%)'
                }
            }
        },
        error: {
            background: 'color-mix(in srgb, {red.500}, transparent 84%)',
            borderColor: 'color-mix(in srgb, {red.700}, transparent 64%)',
            color: '{red.300}',
            detailColor: '{red.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(255, 255, 255, 0.05)',
                focusRing: {
                    color: '{red.300}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {red.300}, transparent 80%)'
                }
            }
        },
        secondary: {
            background: 'color-mix(in srgb, {surface.300}, transparent 84%)',
            borderColor: 'color-mix(in srgb, {surface.700}, transparent 64%)',
            color: '{surface.300}',
            detailColor: '{surface.200}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: 'rgba(255, 255, 255, 0.05)',
                focusRing: {
                    color: '{surface.300}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%)'
                }
            }
        },
        contrast: {
            background: '{surface.0}',
            borderColor: '{surface.100}',
            color: '{surface.950}',
            detailColor: '{surface.900}',
            shadow: '{overlay.popover.shadow}',
            closeButton: {
                hoverBackground: '{surface.100}',
                focusRing: {
                    color: '{surface.950}',
                    shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.950}, transparent 80%)'
                }
            }
        }
    }
};

export default {
    root,
    icon,
    content,
    text,
    summary,
    detail,
    closeButton,
    closeIcon,
    colorScheme
} satisfies ToastDesignTokens;
